import { useEffect, useRef } from "react";
import "./Modal.scss";
interface BaseModalPropsExtended {
	readonly show: boolean;
	readonly close: (() => void) | null;
	readonly children: React.ReactNode;
}
export function BaseModal(props: BaseModalPropsExtended) {
	const modalRef = useRef<HTMLDivElement>(null);
	const prevState = useRef(false);

	useEffect(() => {
		if (modalRef.current == null) return;
		if (props.show == prevState.current) return;
		prevState.current = props.show;

		if (props.show) {
			modalRef.current.style.display = "block";
			modalRef.current.classList.add("in");
			modalRef.current.animate({
				opacity: [0, 1]
			}, {
				duration: 300,
				easing: "ease-in",
				fill: "forwards",
			});


		} else {
			modalRef.current.classList.remove("in");
			const animation = modalRef.current.animate({
				opacity: [1, 0]
			}, {
				duration: 300,
				easing: "ease-out",
				fill: "forwards",
			});

			animation.onfinish = () => {
				if (modalRef.current == null) return;
				modalRef.current.style.display = "none";
			};
		}
	}, [props.show]);

	return (
		<div className="myModal" tabIndex={-1} role="dialog" ref={modalRef} >
			<div className="backdrop" onClick={props.close ?? undefined} />
			<div className="dialog" role="document">
				<div className="modal-content" style={{ maxHeight: "95vh", overflowY: "auto" }}>
					{props.children}
				</div>
			</div>
		</div>
	);
}

export function ModalCloseCross(props: { readonly onClick: (() => void); }) {
	return (
		<button type="button" className="close" aria-label="Close" onClick={props.onClick}>
			<i className="fa fa-times" />
		</button>
	);
}

export interface BaseModalProps {
	readonly show: boolean;
	readonly close: (() => void);
}